import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * checks if the string contains a-z 0-9 or spaces
 */
export const trueAlphaNumeric = (control: AbstractControl): ValidationErrors | null => {
  return new RegExp("^[a-zA-Z0-9 ]*$", "g").test(control.value) ? null : { invalidTrueAlphaNumeric: true };
};
